import {FC} from 'react'
import {useTranslation} from 'react-i18next'

interface BadgeColorOrderProps {
  status: number
  text: string
  type: string
}

export const BadgeColorOrder: FC<BadgeColorOrderProps> = ({text, status, type}) => {
  const {t} = useTranslation()

  if (type === 'header') {
    return (
      <>
        {text == 'Pengajuan Amandemen' ||
        text == 'Amandemen' ||
        text == 'Diamandemen Customer' ||
        text == 'Telah Diamandemen' ||
        text == 'Menunggu Persetujuan Amandemen' ? (
          <span className='badge badge-light-info'>{t('Amandemen')}</span>
        ) : status === 0 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 1 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 2 ? (
          <span className='badge badge-light-warning'>{t(text)}</span>
        ) : status === 3 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 4 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 5 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 6 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 7 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 8 ? (
          <span className='badge badge-light-info'>{t(text)}</span>
        ) : status === 9 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 10 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 11 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : (
          <span className='badge badge-light-danger'>{t(text)}</span>
        )}
      </>
    )
  } else {
    return (
      <>
        {text == 'Pengajuan Amandemen' ||
        text == 'Amandemen' ||
        text == 'Telah Diamandemen' ||
        text == 'Menunggu Persetujuan Amandemen' ? (
          <span className='badge badge-light-info'>{t('Amandemen')}</span>
        ) : status === 0 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 1 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 2 ? (
          <span className='badge badge-light-warning'>{t(text)}</span>
        ) : status === 3 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 4 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 5 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 6 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : status === 7 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 8 ? (
          <span className='badge badge-light-info'>{t(text)}</span>
        ) : status === 9 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 10 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 11 ? (
          <span className='badge badge-light-primary'>{t(text)}</span>
        ) : status === 12 ? (
          <span className='badge badge-light-success'>{t(text)}</span>
        ) : (
          <span className='badge badge-light-danger'>{t(text)}</span>
        )}
      </>
    )
  }
}
